<style>
i.fas.fa-info-circle {
  color: #005295 !important;
  padding-left: 4px;
}
</style>

<i class="fas fa-info-circle fa-md" aria-hidden="true" [pTooltip]="tooltipContent" [fitContent]="false" [tooltipStyleClass]="tooltipStyleClass"></i>
<ng-template #tooltipContent>
  <ng-content></ng-content>
</ng-template>